export var zindexNavbar = 1000;
export var zindexDropdown = 1000;
export var zindexPopover = 1060;
export var zindexTooltip = 1070;
export var zindexNavbarFixed = 1030;
export var zindexModalBackground = 1040;
export var zindexModal = 1050;
export default undefined;